(function () {
  let sliders = [];
  let tickerAdded = false;

  const BASE_LERP_FACTOR = 0.3;
  const TOUCH_DRAG_LERP_FACTOR = 0.05;

  function tick() {
    sliders.forEach((s) => s.update());
  }

  // Con variableWidth: true il drag di Smooothy è sempre 1:1 (px trascinato
  // = px di scroll), quindi su mobile basta stringere il lerp perché
  // `current` insegua `target` quasi senza ritardo. Al rilascio torniamo al
  // lerp di base, che dà un coast/snap più morbido (un po' di inerzia). Il
  // drag da mouse non passa da qui e resta invariato.
  function bindOneToOneTouch(loopEl, slider) {
    if (loopEl.__oneToOneTouchBound) return;
    loopEl.__oneToOneTouchBound = true;

    loopEl.addEventListener(
      'touchstart',
      () => {
        slider.config.lerpFactor = TOUCH_DRAG_LERP_FACTOR;
      },
      { passive: true },
    );

    const restoreBaseFeel = () => {
      slider.config.lerpFactor = BASE_LERP_FACTOR;
    };
    loopEl.addEventListener('touchend', restoreBaseFeel);
    loopEl.addEventListener('touchcancel', restoreBaseFeel);
  }

  function initMainBlogLoop() {
    sliders.forEach((s) => s.destroy());
    sliders = [];

    const loopEl = document.querySelector('[data-main-blog-loop]');

    // Ferma lo scroll nativo della pagina (Lenis) solo su questa sezione: la
    // wheel/drag di Smooothy sostituisce completamente lo scroll di pagina.
    if (window.lenis) {
      if (loopEl) window.lenis.stop();
      else window.lenis.start();
    }

    if (!loopEl || loopEl.children.length < 2) return;

    const slider = new Smooothy(loopEl, {
      infinite: true,
      vertical: true,
      snap: true,
      variableWidth: true,
      lerpFactor: BASE_LERP_FACTOR,
    });
    slider.init();
    bindOneToOneTouch(loopEl, slider);
    sliders.push(slider);

    if (sliders.length > 0 && !tickerAdded) {
      gsap.ticker.add(tick);
      tickerAdded = true;
    }
  }

  initMainBlogLoop();

  document.addEventListener('page:loaded', () => initMainBlogLoop());
})();
